import React from 'react';
import { useEffect } from 'react';
import Layout from '../../Layout/Layout';
import { Container, Row, Col } from 'reactstrap';
import TitleBar from '../../Layout/TitleBar';
import {
  CookbookMealListEdge,
  withLoading,
  callNativeMobileApp,
  DietTypesSliderCookbookCategory,
  ListCookbookCategory,
  SliderCookbookCategory,
  CookbookTag,
} from '@front-activerse/common-components';
import CookbookMealItem from '../components/CookbookMealItem';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';

import { useOutletContext } from 'react-router-dom';

interface ICookbookMealListContainer {
  mealTypeTags: CookbookTag[];
  categories: (SliderCookbookCategory | ListCookbookCategory | DietTypesSliderCookbookCategory)[];
  categoryId?: string;
  mealTypeTagId?: string;
  meals: CookbookMealListEdge[];
  addToFavorites: (mealId: number) => Promise<unknown>;
  removeFromFavorites: (mealId: number) => Promise<unknown>;
}

export const CookbookIndexContainer: React.FC<ICookbookMealListContainer> = ({
  mealTypeTags,
  categories,
  categoryId,
  mealTypeTagId,
  meals,
  addToFavorites,
  removeFromFavorites,
}) => {
  const { trackFirebaseEvent } = useOutletContext<{
    trackFirebaseEvent: (eventName: string, eventPayload: object) => void;
  }>();

  useEffect(() => {
    if (
      (window.location.pathname.startsWith('/meals/cookbook/category/') &&
        window.location.pathname.split('/').length === 5) ||
      (window.location.pathname.startsWith('/meals/cookbook/tag/') &&
        window.location.pathname.split('/').length === 6)
    ) {
      const categoryName = findCategoryName();
      if (categoryName) {
        callNativeMobileApp({
          action: 'title_changed',
          payload: {
            title: categoryName,
          },
        });
      }

      trackFirebaseEvent('screen_view', {
        firebase_screen: 'Cookbook_all_meals',
        selected_diet: categoryId,
        cookbook_meal_type: mealTypeTagId,
        meals_tab: 'cookbook',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, mealTypeTagId, window.location.pathname]);

  const findCategoryName = () => {
    if (mealTypeTagId && window.location.pathname.startsWith('/meals/cookbook/tag/')) {
      return mealTypeTags.find((tag) => tag.id === +mealTypeTagId)?.name;
    } else if (categoryId && window.location.pathname.startsWith('/meals/cookbook/category/')) {
      return categories.find((category) => category.id === +categoryId)?.name;
    }

    return null;
  };

  return (
    <Layout>
      <TitleBar level={1}>{findCategoryName()}</TitleBar>
      <div className="page-template-cookbook full-height3">
        <Container className="py-md-4">
          <Row>
            <Col xl={{ size: 10, offset: 1 }}>
              <div className="page-container">
                <div className="cookbook-category">
                  <Row className="cookbook-meals">
                    {meals.map(({ node }) => (
                      <CookbookMealItem
                        key={node.id}
                        {...node}
                        addToFavorites={addToFavorites}
                        removeFromFavorites={removeFromFavorites}
                        orientation="horizontal"
                      />
                    ))}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

const Placeholder = () => <UniversalPlaceholder titleBar="" />;

export default withLoading(CookbookIndexContainer, Placeholder);
